// 设置网页标题
document.title = "祎风科技 - XR教育培训解决方案";

// 基于公司官网样式的滚动式模块UI实现
console.log("🎨 CompanyStyleModuleUI 开始加载...");

// 🎨 卡片对应的状态栏背景色配置
const cardColors = [
    'rgba(16, 41, 72, 1)',      // 卡片1
    'rgba(187, 149, 115, 1)',   // 卡片2
    'rgba(15, 71, 204, 1)',     // 卡片3
    'rgba(91, 137, 142, 1)',    // 卡片4
    'rgba(203, 238, 255, 1)',   // 卡片5
    'rgba(108, 132, 159, 1)',   // 卡片6 - 全景工厂（改为素雅的蓝灰色）
    'rgba(169, 219, 192, 1)',   // 卡片7
    'rgba(0, 0, 0, 1)',         // 卡片8
    'rgba(0, 0, 0, 1)'          // 卡片9
];

// 🚀 场景切换管理器 - 增加缓存支持
const sceneTransitionManager = {
    isTransitioning: false,
    lastTransitionTime: 0,
    transitionCooldown: 800,
    currentTargetCard: -1,
    lastQueuedCard: -1,
    transitionTimeout: null,    // 用于存储超时定时器

    // 检查是否可以执行新的场景切换
    canTransition: function (cardIndex) {
        const now = Date.now();
        const timeSinceLastTransition = now - this.lastTransitionTime;

        // 缓存场景使用更短的冷却时间
        const actualCooldown = sceneCacheManager.isCached(cardIndex)
            ? this.transitionCooldown * 0.3  // 进一步减少缓存场景的冷却时间
            : this.transitionCooldown;

        if (this.isTransitioning) {
            // 如果新的目标与当前不同，取消当前转换
            if (this.currentTargetCard !== cardIndex) {
                this.cancelCurrentTransition();
                return true;  // 允许立即切换到新目标
            }
            return false;
        }

        if (timeSinceLastTransition < actualCooldown) {
            if (this.lastQueuedCard !== cardIndex) {
                this.lastQueuedCard = cardIndex;
                console.log(`⏳ 更新目标卡片: ${cardIndex + 1}`);
            }
            return false;
        }

        return true;
    },

    // 取消当前转换
    cancelCurrentTransition: function () {
        if (this.transitionTimeout) {
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = null;
        }
        this.isTransitioning = false;
        console.log(`❌ 取消当前场景切换`);
    },

    // 开始场景切换
    startTransition: function (cardIndex) {
        // 取消之前的转换
        this.cancelCurrentTransition();

        this.isTransitioning = true;
        this.lastTransitionTime = Date.now();
        this.currentTargetCard = cardIndex;

        const isCached = sceneCacheManager.isCached(cardIndex);
        console.log(`🎬 开始切换到${isCached ? '缓存' : '新'}场景: ${cardIndex + 1}`);

        // 设置新的超时保护
        this.transitionTimeout = setTimeout(() => {
            if (this.isTransitioning && this.currentTargetCard === cardIndex) {
                console.warn(`⚠️ 场景切换超时，强制重置状态`);
                this.endTransition();
            }
        }, 3000);
    },

    // 结束场景切换
    endTransition: function () {
        // 缓存当前场景
        if (this.currentTargetCard !== -1 && window.TimelineControl && window.TimelineControl.current) {
            const currentScene = window.TimelineControl.current();
            if (currentScene) {
                sceneCacheManager.addToCache(this.currentTargetCard, currentScene);
            }
        }

        this.cancelCurrentTransition();  // 清理超时定时器
        this.currentTargetCard = -1;
        console.log(`✅ 场景切换完成`);

        // 检查是否有最后的切换请求需要处理
        if (this.lastQueuedCard !== -1) {
            const nextCardIndex = this.lastQueuedCard;
            this.lastQueuedCard = -1;

            // 立即执行下一个切换，不等待冷却时间
            if (typeof window.TimelineControl !== 'undefined' && window.TimelineControl.jumpToCard) {
                console.log(`🔄 立即执行最后的场景切换请求: ${nextCardIndex + 1}`);

                const cachedScene = sceneCacheManager.getFromCache(nextCardIndex);
                if (cachedScene) {
                    console.log(`💫 使用缓存加速切换`);
                }

                const jumpResult = window.TimelineControl.jumpToCard(nextCardIndex, true);
                if (jumpResult) {
                    this.startTransition(nextCardIndex);
                    // 进一步优化加载时间
                    const loadTime = sceneCacheManager.isCached(nextCardIndex) ? 400 : 1000;
                    setTimeout(() => this.endTransition(), loadTime);
                }
            }
        }

        // 定期清理过期缓存
        sceneCacheManager.clearOldCache();
    }
};

// 🔧 调试功能 - 帮助诊断滚轮控制问题
function debugWheelControl() {
    console.log("🔍 滚轮控制诊断开始...");

    // 检查滚轮事件监听器
    setTimeout(() => {
        const panel = document.getElementById('scroll-control-panel');
        console.log(`📋 控制面板状态: ${panel ? '✅ 已创建' : '❌ 未创建'}`);

        if (panel) {
            console.log(`🎛️ 面板位置: top=${panel.style.top}, left=${panel.style.left}`);
            console.log(`🎛️ 面板可见性: display=${panel.style.display}, opacity=${panel.style.opacity}`);

            // 强制确保面板可见
            panel.style.display = 'block';
            panel.style.opacity = '1';
            panel.style.visibility = 'visible';
            panel.style.zIndex = '99999';
            console.log("🔧 强制显示控制面板");
        }

        console.log(`⚙️ scrollConfig.enabled: ${scrollConfig.enabled}`);
        console.log(`🎚️ scrollConfig.speed: ${scrollConfig.speed}`);
        console.log(`🎚️ scrollConfig.smoothing: ${scrollConfig.smoothing}`);
        console.log(`🎚️ scrollConfig.acceleration: ${scrollConfig.acceleration}`);

        // 手动测试滚轮事件
        console.log("📝 手动测试滚轮事件...");
        try {
            const testEvent = new WheelEvent('wheel', {
                deltaY: 100,
                bubbles: true,
                cancelable: true
            });

            // 测试我们的自定义处理函数
            handleCustomWheel(testEvent);
            console.log("✅ 自定义滚轮处理函数工作正常");
        } catch (error) {
            console.error("❌ 滚轮事件测试失败:", error);
        }

        // 添加全局调试命令
        window.WheelDebug = {
            testScroll: (deltaY = 100) => {
                console.log(`🧪 手动测试滚轮 deltaY=${deltaY}`);
                const event = new WheelEvent('wheel', { deltaY, bubbles: true, cancelable: true });
                handleCustomWheel(event);
            },
            showPanel: () => {
                const panel = document.getElementById('scroll-control-panel');
                if (panel) {
                    panel.style.display = 'block';
                    panel.style.opacity = '1';
                    panel.style.visibility = 'visible';
                    console.log("🎛️ 控制面板已强制显示");
                } else {
                    console.log("❌ 控制面板不存在，重新创建...");
                    createScrollControlPanel();
                }
            },
            getConfig: () => {
                console.log("📊 当前滚轮控制配置:", scrollConfig);
                return scrollConfig;
            },
            forceEnable: () => {
                scrollConfig.enabled = true;
                console.log("🔛 强制启用滚轮控制");
                // 更新UI
                const statusSpan = document.getElementById('wheel-status');
                const toggleButton = document.getElementById('toggle-wheel-control');
                if (statusSpan) statusSpan.textContent = '启用';
                if (toggleButton) {
                    toggleButton.textContent = '禁用控制';
                    toggleButton.style.background = '#4CAF50';
                }
            }
        };

        console.log("🛠️ 调试命令已添加到 window.WheelDebug");
        console.log("💡 可用命令:");
        console.log("   WheelDebug.testScroll(100) - 测试滚轮事件");
        console.log("   WheelDebug.showPanel() - 显示控制面板");
        console.log("   WheelDebug.getConfig() - 获取配置");
        console.log("   WheelDebug.forceEnable() - 强制启用");

    }, 2000);
}

// 🎛️ 滚轮速率控制配置
const scrollConfig = {
    enabled: false,          // 禁用自定义滚轮控制
    speed: 1.0,             // 恢复默认速度
    smoothing: 0.15,        // 恢复默认平滑度
    acceleration: 1.0,      // 恢复默认加速度
    maxDelta: 100,         // 恢复默认最大增量
    debounceTime: 16       // 恢复默认防抖时间
};

// 🎛️ 滚轮控制状态
let wheelControlState = {
    isScrolling: false,
    lastWheelTime: 0,
    accumulatedDelta: 0,
    rafId: null
};

// 🎛️ 轻量级滚动控制函数
function lightweightScrollControl(event) {
    // 由于已禁用，直接返回
    return;
}

// 🎛️ 自定义速度控制函数
function customSpeedControl(event) {
    // 由于已禁用，直接返回
    return;
}

// 🎛️ 初始化自定义滚轮控制
function initCustomWheelControl() {
    console.log("🎛️ 禁用所有自定义滚轮控制");

    try {
        // 移除所有可能的滚轮事件监听器
        document.removeEventListener('wheel', handleCustomWheel);
        document.removeEventListener('wheel', lightweightScrollControl);
        document.removeEventListener('wheel', customSpeedControl);

        // 清理滚轮控制状态
        wheelControlState = {
            isScrolling: false,
            lastWheelTime: 0,
            accumulatedDelta: 0,
            rafId: null
        };

        // 如果存在动画帧，取消它
        if (wheelControlState.rafId) {
            cancelAnimationFrame(wheelControlState.rafId);
            wheelControlState.rafId = null;
        }

        console.log("✅ 已恢复原生滚动行为");
    } catch (error) {
        console.error("❌ 移除滚轮控制时出错:", error);
    }
}

// 🎛️ 自定义滚轮处理函数
function handleCustomWheel(event) {
    // 由于已禁用，直接返回
    return;
}

// 🎛️ 应用累积的滚动
function applyAccumulatedScroll() {
    // 由于已禁用，直接返回
    return;
}

// 🎛️ 创建滚动控制面板
function createScrollControlPanel() {
    const panel = document.createElement('div');
    panel.id = 'scroll-control-panel';
    panel.style.cssText = `
        position: fixed;
        top: 20px;
        left: 20px;
        background: linear-gradient(135deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.9) 100%);
        color: white;
        padding: 15px;
        border-radius: 12px;
        font-size: 12px;
        font-family: monospace;
        z-index: 10000;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        min-width: 250px;
        user-select: none;
    `;

    panel.innerHTML = `
        <div style="font-weight: bold; margin-bottom: 10px; color: #4CAF50;">🎛️ 滚轮控制面板</div>
        
        <div style="margin-bottom: 8px;">
            <label>滚轮速度: <span id="speed-value">${scrollConfig.speed}</span></label>
            <input type="range" id="speed-slider" min="0.1" max="2.0" step="0.1" value="${scrollConfig.speed}" 
                style="width: 100%; margin-top: 2px;">
        </div>
        
        <div style="margin-bottom: 8px;">
            <label>平滑度: <span id="smoothing-value">${scrollConfig.smoothing}</span></label>
            <input type="range" id="smoothing-slider" min="0.05" max="0.5" step="0.05" value="${scrollConfig.smoothing}"
                style="width: 100%; margin-top: 2px;">
        </div>
        
        <div style="margin-bottom: 8px;">
            <label>加速度: <span id="acceleration-value">${scrollConfig.acceleration}</span></label>
            <input type="range" id="acceleration-slider" min="1.0" max="3.0" step="0.1" value="${scrollConfig.acceleration}"
                style="width: 100%; margin-top: 2px;">
        </div>
        
        <div style="display: flex; gap: 8px; margin-top: 10px;">
            <button id="toggle-wheel-control" style="
                flex: 1; padding: 4px 8px; border: none; border-radius: 6px; 
                background: #4CAF50; color: white; cursor: pointer; font-size: 11px;
            ">禁用控制</button>
            <button id="reset-defaults" style="
                flex: 1; padding: 4px 8px; border: none; border-radius: 6px; 
                background: #FF9800; color: white; cursor: pointer; font-size: 11px;
            ">重置默认</button>
        </div>
        
        <div style="margin-top: 8px; font-size: 10px; opacity: 0.8;">
            状态: <span id="wheel-status">启用</span> | 卡片: <span id="current-card">1</span>/9
        </div>
    `;

    document.body.appendChild(panel);

    // 绑定控制事件
    setupControlPanelEvents();
}

// 🎛️ 设置控制面板事件
function setupControlPanelEvents() {
    // 速度控制
    const speedSlider = document.getElementById('speed-slider');
    const speedValue = document.getElementById('speed-value');
    if (speedSlider && speedValue) {
        speedSlider.addEventListener('input', (e) => {
            scrollConfig.speed = parseFloat(e.target.value);
            speedValue.textContent = scrollConfig.speed;
            console.log(`🎛️ 滚轮速度调整为: ${scrollConfig.speed}`);
        });
    }

    // 平滑度控制
    const smoothingSlider = document.getElementById('smoothing-slider');
    const smoothingValue = document.getElementById('smoothing-value');
    if (smoothingSlider && smoothingValue) {
        smoothingSlider.addEventListener('input', (e) => {
            scrollConfig.smoothing = parseFloat(e.target.value);
            smoothingValue.textContent = scrollConfig.smoothing;
            console.log(`🎛️ 平滑度调整为: ${scrollConfig.smoothing}`);
        });
    }

    // 加速度控制
    const accelerationSlider = document.getElementById('acceleration-slider');
    const accelerationValue = document.getElementById('acceleration-value');
    if (accelerationSlider && accelerationValue) {
        accelerationSlider.addEventListener('input', (e) => {
            scrollConfig.acceleration = parseFloat(e.target.value);
            accelerationValue.textContent = scrollConfig.acceleration;
            console.log(`🎛️ 加速度调整为: ${scrollConfig.acceleration}`);
        });
    }

    // 开关控制
    const toggleButton = document.getElementById('toggle-wheel-control');
    const statusSpan = document.getElementById('wheel-status');
    if (toggleButton && statusSpan) {
        toggleButton.addEventListener('click', () => {
            scrollConfig.enabled = !scrollConfig.enabled;
            toggleButton.textContent = scrollConfig.enabled ? '禁用控制' : '启用控制';
            toggleButton.style.background = scrollConfig.enabled ? '#4CAF50' : '#f44336';
            statusSpan.textContent = scrollConfig.enabled ? '启用' : '禁用';
            console.log(`🎛️ 滚轮控制: ${scrollConfig.enabled ? '启用' : '禁用'}`);
        });
    }

    // 重置按钮
    const resetButton = document.getElementById('reset-defaults');
    if (resetButton) {
        resetButton.addEventListener('click', () => {
            scrollConfig.speed = 0.8;
            scrollConfig.smoothing = 0.15;
            scrollConfig.acceleration = 1.2;

            if (speedSlider && speedValue) {
                speedSlider.value = scrollConfig.speed;
                speedValue.textContent = scrollConfig.speed;
            }
            if (smoothingSlider && smoothingValue) {
                smoothingSlider.value = scrollConfig.smoothing;
                smoothingValue.textContent = scrollConfig.smoothing;
            }
            if (accelerationSlider && accelerationValue) {
                accelerationSlider.value = scrollConfig.acceleration;
                accelerationValue.textContent = scrollConfig.acceleration;
            }

            console.log('🎛️ 滚轮控制参数已重置为默认值');
        });
    }
}

// 🎛️ 更新当前卡片显示
function updateCurrentCardDisplay() {
    const currentCardSpan = document.getElementById('current-card');
    if (currentCardSpan) {
        currentCardSpan.textContent = currentModuleIndex + 1;
    }
}

// 🎛️ 公共接口
window.ScrollWheelControl = {
    // 启用/禁用滚轮控制
    toggle: (enabled) => {
        scrollConfig.enabled = enabled;
        const statusSpan = document.getElementById('wheel-status');
        const toggleButton = document.getElementById('toggle-wheel-control');
        if (statusSpan) statusSpan.textContent = enabled ? '启用' : '禁用';
        if (toggleButton) {
            toggleButton.textContent = enabled ? '禁用控制' : '启用控制';
            toggleButton.style.background = enabled ? '#4CAF50' : '#f44336';
        }
        console.log(`🎛️ 滚轮控制: ${enabled ? '启用' : '禁用'}`);
    },

    // 设置滚轮速度
    setSpeed: (speed) => {
        scrollConfig.speed = Math.max(0.1, Math.min(2.0, speed));
        const speedValue = document.getElementById('speed-value');
        const speedSlider = document.getElementById('speed-slider');
        if (speedValue) speedValue.textContent = scrollConfig.speed;
        if (speedSlider) speedSlider.value = scrollConfig.speed;
        console.log(`🎛️ 滚轮速度: ${scrollConfig.speed}`);
    },

    // 设置平滑度
    setSmoothing: (smoothing) => {
        scrollConfig.smoothing = Math.max(0.05, Math.min(0.5, smoothing));
        const smoothingValue = document.getElementById('smoothing-value');
        const smoothingSlider = document.getElementById('smoothing-slider');
        if (smoothingValue) smoothingValue.textContent = scrollConfig.smoothing;
        if (smoothingSlider) smoothingSlider.value = scrollConfig.smoothing;
        console.log(`🎛️ 平滑度: ${scrollConfig.smoothing}`);
    },

    // 获取当前配置
    getConfig: () => ({ ...scrollConfig }),

    // 隐藏/显示控制面板
    togglePanel: () => {
        const panel = document.getElementById('scroll-control-panel');
        if (panel) {
            panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
        }
    }
};

// 模块数据 - 7个业务模块 + 关于公司 + 联系我们 = 9个模块
const modules = [
    {
        id: 1,
        title: "数字孪生决策沙盘",
        subtitle: "一屏统览，决策有据",
        description: "用3D地图精准还原城市、园区或工厂实景，接入摄像头、传感器和业务数据，实时监控运行状态，模拟灾害影响，辅助管理者快速决策。支持台风、洪涝、火灾等多种应急场景推演，智能分析最优疏散路线和资源配置方案。通过可视化大屏联动，实现多部门协同指挥，显著降低应急响应时间，提升资源调度效率。",
        features: [
            "真实场景3D还原",
            "实时数据监控预警",
            "多部门协同指挥"
        ],
        primaryBtn: "查看沙盘方案",
        secondaryBtn: "预约演示",
        theme: "#667eea"
    },
    {
        id: 2,
        title: "智能产线监控系统",
        subtitle: "虚实结合，产线增效",
        description: "为真实生产线创建1:1虚拟模型，实时监控设备运行状态（温度、振动、能耗），预测故障，远程指导维修，优化生产工艺。集成IoT传感器网络和边缘计算技术，支持设备健康度评估、故障预警、维护计划智能排程。通过AR眼镜实现远程专家现场指导，有效减少设备停机时间，显著提高生产效率，保障产品质量一致性。",
        features: [
            "产线实时虚拟映射",
            "设备预测性维护",
            "AR远程专家支持"
        ],
        primaryBtn: "了解产线方案",
        secondaryBtn: "查看案例效果",
        theme: "#764ba2"
    },
    {
        id: 3,
        title: "元宇宙互动教学平台",
        subtitle: "沉浸学习，安全实训",
        description: "创建3D虚拟教室和实验室，支持远程多人互动教学，安全模拟高危操作（如化工、电力）和精密设备拆装（如飞机引擎）。采用高精度物理引擎和真实材料属性仿真，支持多人同时在线协作学习。集成AI智能导师系统，实时监测学习行为，提供个性化指导。解决实操风险高、成本大、场地限制问题，显著提升学习效果和知识留存率。",
        features: [
            "多人3D互动教室",
            "高危/精密操作模拟",
            "学习效果智能分析"
        ],
        primaryBtn: "体验教学平台",
        secondaryBtn: "申请试用",
        theme: "#f093fb"
    },
    {
        id: 4,
        title: "AI多角色训练助手",
        subtitle: "智能陪练，成长加速",
        description: "企业版：模拟各类顾客性格和需求，训练销售人员应对技巧，智能分析对话中的应答漏洞和改进建议，支持金融、汽车、房产等行业定制场景。学校版：担任全天候在线心理辅导助手，通过语音语调和表情识别学生情绪状态，及时预警心理健康风险。增值服务：虚拟拍摄，通过动作捕捉和面部捕捉技术生成逼真数字人，可用于数字人直播、虚拟主播、品牌代言等多种商业应用。有效降低培训成本，显著提升训练效率和员工满意度。",
        features: [
            "逼真角色场景模拟",
            "语音情绪智能分析",
            "虚拟拍摄数字人生成",
            "数字人直播应用",
            "训练报告自动生成"
        ],
        primaryBtn: "定制数字陪练",
        secondaryBtn: "在线体验",
        theme: "#667eea"
    },
    {
        id: 5,
        title: "XR企业教育实训",
        subtitle: "沉浸教学，技能提升",
        description: "将传统教学与VR/AR技术深度融合，构建沉浸式教育实训环境。从企业技能培训到院校专业教学，覆盖建筑、医疗、机械、美容、食品等多领域。学员在安全的虚拟环境中反复练习复杂操作，AI系统提供个性化指导和精准评估。支持理论与实践有机结合，显著提升教学效果和学习效率，培养符合行业需求的高技能人才。",
        features: [
            "多领域教学场景构建",
            "理实一体化教学模式",
            "AI个性化学习评估"
        ],
        primaryBtn: "体验教学方案",
        secondaryBtn: "获取教育案例",
        theme: "#764ba2"
    },
    {
        id: 6,
        title: "VR全景工厂展厅",
        subtitle: "足不出户，看遍工厂",
        description: "用高清全景相机拍摄真实工厂、展厅或设备，生成沉浸式VR漫游体验。客户戴上VR头盔即可身临其境参观，点击热点查看设备详情、技术参数和应用案例。支持多语种语音讲解、产品3D模型展示、视频演示播放。突破地域限制，大幅降低线下展示成本，显著提升客户参观体验和销售转化率。",
        features: [
            "高清实景VR漫游",
            "热点信息标注展示",
            "多平台便捷访问"
        ],
        primaryBtn: "在线看厂",
        secondaryBtn: "打造VR展厅",
        theme: "#f093fb"
    },
    {
        id: 7,
        title: "虚拟仿真实训基地建设",
        subtitle: "一站式虚拟实训室",
        description: "规划建设集成VR教室、MR工坊、专业仿真软件（如Kmax）的综合实训基地，提供从硬件部署、课程开发到数据管理的全套服务。支持不同规模的实训中心建设，涵盖理论教学、虚拟实验、技能考核、数据分析全流程。配备专业师资培训、课程内容定制、运营管理指导。满足高校、企业建设现代化、高效率实训中心的需求，有效降低建设成本，显著提升设备利用率。",
        features: [
            "VR/MR/仿真实验室建设",
            "专业虚拟课程开发",
            "实训数据统一管理"
        ],
        primaryBtn: "咨询基地建设",
        secondaryBtn: "获取方案书",
        detailUrl: "virtual-simulation-base.html",
        theme: "#667eea"
    },
    {
        id: 8,
        title: "关于祎风科技",
        subtitle: "专业XR技术服务商",
        description: "祎风科技成立于2020年，是一家专注于XR技术教育培训应用的国家高新技术企业。公司汇聚来自清华、北航、中科院等顶尖院校的技术精英，拥有VR/AR/MR全栈开发能力与深厚的教育行业洞察。我们致力于推动XR技术在教育培训领域的深度融合与创新应用，已为政府机构、央企国企、知名高校、医疗机构等提供专业服务。荣获国家科技进步奖、教育部产学合作协同育人项目等多项荣誉，是行业领先的XR教育解决方案提供商。",
        features: [
            "50+ 成功项目交付经验",
            "100,000+ 全球用户服务覆盖",
            "20+ 战略合作伙伴生态",
            "国家高新技术企业认证",
            "顶尖院校技术团队背景",
            "教育部产学合作项目承担"
        ],
        primaryBtn: "了解更多",
        secondaryBtn: "查看案例",
        theme: "#764ba2"
    },
    {
        id: 9,
        title: "联系我们",
        subtitle: "开启XR教育培训之旅",
        description: "准备开启XR教育培训数字化转型之旅？我们的资深专家团队随时为您提供专业技术咨询、定制化解决方案设计、项目实施指导等全方位服务支持。无论您是教育机构、企业培训部门，还是政府相关部门，我们都能为您量身打造最适合的XR教育培训解决方案，助力您在数字化教育浪潮中抢占先机，实现教学模式的革命性升级。",
        features: [
            "📧 contact@yifengtech.com",
            "📱 13564719755 (唐先生)",
            "📍 上海市虹口区瑞虹企业天地1号楼1009",
            "💬 7×24小时专业咨询服务",
            "📋 免费定制解决方案设计",
            "🎯 一对一项目实施指导"
        ],
        primaryBtn: "立即咨询",
        secondaryBtn: "下载案例",
        theme: "#f093fb"
    }
];

let currentModuleIndex = 0;

// 在现有滚动容器中添加模块，并清理所有原有内容
function addModulesToExistingContainer() {
    console.log("🏗️ 创建9个模块的完整滚动页面（7个业务+关于公司+联系我们）");

    // 检查是否已经初始化过且完整
    const existingModules = document.querySelectorAll('[id^="module-section-"]');
    if (existingModules.length === 9 && !isInitialized) {
        console.log("ℹ️ 模块已存在且完整，跳过重复初始化");
        return;
    }

    if (existingModules.length > 0 && existingModules.length < 9) {
        console.log(`🔧 检测到不完整的模块 (${existingModules.length}/9)，清理后重建`);
    }

    // 查找现有的滚动容器
    const existingScrollContainer = document.querySelector('.scroll-container');
    if (!existingScrollContainer) {
        console.warn("⚠️ 未找到现有滚动容器，创建新的");
        createNewScrollContainer();
        return;
    }

    // 清理可能存在的原有内容（HTML已经是空的了，这里只是保险）
    const existingSections = existingScrollContainer.querySelectorAll('section');
    if (existingSections.length > 0) {
        console.log(`🧹 清理 ${existingSections.length} 个遗留模块`);
        existingSections.forEach(section => section.remove());
    }

    // 添加我们的9个模块 - 强化版
    modules.forEach((module, index) => {
        const section = createModuleSection(module, index);

        // 添加保护属性
        section.setAttribute('data-protected', 'true');
        section.setAttribute('data-module-id', module.id);

        // 添加强制显示样式，防止被CSS隐藏
        section.style.setProperty('display', 'flex', 'important');
        section.style.setProperty('visibility', 'visible', 'important');
        section.style.setProperty('opacity', '1', 'important');

        existingScrollContainer.appendChild(section);
        console.log(`✅ 模块${module.id}已创建: ${module.title}`);

        // 立即验证模块是否成功添加
        setTimeout(() => {
            const addedSection = document.getElementById(`module-section-${module.id}`);
            if (!addedSection) {
                console.error(`❌ 模块${module.id}添加失败，重试...`);
                const retrySection = createModuleSection(module, index);
                retrySection.setAttribute('data-protected', 'true');
                retrySection.setAttribute('data-module-id', module.id);
                existingScrollContainer.appendChild(retrySection);
            }
        }, 50);
    });

    console.log("✅ 9个模块已添加到滚动容器，替换所有原有内容");

    // 设置滚动监听
    setupScrollListener();

    // 验证所有模块是否正确创建
    setTimeout(() => {
        const finalModuleCount = document.querySelectorAll('[id^="module-section-"]').length;
        console.log(`📊 最终模块数量验证: ${finalModuleCount}/9`);

        if (finalModuleCount !== 9) {
            console.error("❌ 模块创建不完整，可能存在冲突");
        }
    }, 100);
}

// 创建新的滚动容器（备用方案）
function createNewScrollContainer() {
    console.log("🏗️ 创建新的滚动容器");

    const scrollContainer = document.createElement('div');
    scrollContainer.className = 'scroll-container company-modules';
    scrollContainer.style.cssText = `
        position: relative;
        z-index: 2;
        pointer-events: none;
        width: 100%;
        height: auto;
    `;

    // 创建所有模块的section
    modules.forEach((module, index) => {
        const section = createModuleSection(module, index);
        scrollContainer.appendChild(section);
    });

    document.body.appendChild(scrollContainer);
    console.log("✅ 新的滚动容器创建完成");

    // 设置滚动监听
    setupScrollListener();
}

// 创建单个模块section - 完全基于公司官网样式
function createModuleSection(module, index) {
    const section = document.createElement('section');
    section.id = `module-section-${module.id}`;
    section.className = 'content-section products-section';
    section.style.cssText = `
        min-height: 100vh;
        display: flex;
        align-items: center;
        padding: 140px 0 80px 0;
        pointer-events: none;
    `;

    section.innerHTML = `
        <div class="content-right" style="
            margin-left: auto;
            margin-right: 40px;
            width: 100%;
            max-width: 650px;
            pointer-events: auto;
        ">
            <div class="glass-card product-card" style="
                background: linear-gradient(135deg, 
                    rgba(255, 255, 255, 0.18) 0%, 
                    rgba(255, 255, 255, 0.08) 100%);
                backdrop-filter: blur(25px) saturate(200%);
                -webkit-backdrop-filter: blur(25px) saturate(200%);
                border: 1px solid rgba(255, 255, 255, 0.3);
                border-radius: 24px;
                box-shadow: 
                    0 8px 32px rgba(0, 0, 0, 0.12),
                    0 16px 48px rgba(0, 0, 0, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.4);
                padding: 40px;
                transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                position: relative;
                overflow: hidden;
            ">
                <!-- 产品头部 -->
                <div class="product-header" style="margin-bottom: 32px;">
                    <h3 class="product-title" style="
                        font-family: 'Orbitron', 'Inter', sans-serif;
                        font-weight: 700;
                        font-size: 36px;
                        color: white !important;
                        margin: 0 0 12px 0;
                        line-height: 1.2;
                        text-shadow: 0 2px 10px rgba(255, 255, 255, 0.3);
                        display: block !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                        letter-spacing: -0.02em;
                    ">${module.title}</h3>
                    <p class="product-subtitle" style="
                        font-weight: 500;
                        font-size: 18px;
                        color: ${module.theme} !important;
                        margin: 0;
                        text-shadow: 0 1px 5px rgba(255, 255, 255, 0.2);
                        display: block !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                    ">${module.subtitle}</p>
                </div>
                
                <!-- 产品描述 - 强制完整显示 -->
                <div class="product-description" style="
                    font-size: 14px;
                    line-height: 1.6;
                    color: rgba(255, 255, 255, 0.9) !important;
                    margin: 0 0 24px 0;
                    text-align: justify;
                    word-wrap: break-word;
                    word-break: break-word;
                    white-space: normal;
                    overflow: visible !important;
                    max-height: none !important;
                    height: auto !important;
                    min-height: auto !important;
                    display: block !important;
                    visibility: visible !important;
                    opacity: 1 !important;
                    width: 100% !important;
                    box-sizing: border-box !important;
                    max-width: 520px;
                ">${module.description}</div>
                
                <!-- 功能特性标签 - 基于公司官网样式 -->
                <div class="product-features" style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                    margin-bottom: 32px;
                ">
                    ${module.features.map(feature => `
                        <span class="feature-tag" style="
                            background: linear-gradient(135deg, 
                                rgba(255, 255, 255, 0.15) 0%, 
                                rgba(255, 255, 255, 0.05) 100%);
                            border: 1px solid rgba(255, 255, 255, 0.2);
                            border-radius: 12px;
                            padding: 6px 12px;
                            font-size: 12px;
                            font-weight: 500;
                            color: rgba(255, 255, 255, 0.9) !important;
                            text-align: center;
                            transition: all 0.3s ease;
                            cursor: pointer;
                            position: relative;
                            overflow: hidden;
                            white-space: nowrap;
                            flex-shrink: 0;
                            display: inline-block !important;
                            visibility: visible !important;
                            opacity: 1 !important;
                        " onmouseover="
                            this.style.background='linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%)'; 
                            this.style.borderColor='rgba(255, 255, 255, 0.4)';
                            this.style.transform='translateY(-2px)';
                            this.style.boxShadow='0 4px 15px rgba(255, 255, 255, 0.2)';
                        " onmouseout="
                            this.style.background='linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%)'; 
                            this.style.borderColor='rgba(255, 255, 255, 0.2)';
                            this.style.transform='translateY(0)';
                            this.style.boxShadow='none';
                        ">${feature}</span>
                    `).join('')}
                </div>
                
                <!-- 按钮区域 - 基于公司官网样式 -->
                <div class="product-buttons" style="
                    display: flex;
                    gap: 10px;
                    justify-content: flex-start;
                ">
                    <a href="#contact" class="product-btn primary btn-${module.id}-primary" style="
                        background: linear-gradient(135deg, ${module.theme} 0%, ${module.theme}dd 100%);
                        color: white;
                        text-decoration: none;
                        padding: 8px 16px;
                        border-radius: 16px;
                        font-weight: 600;
                        font-size: 12px;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        box-shadow: 0 2px 8px ${module.theme}40;
                        position: relative;
                        overflow: hidden;
                        text-align: center;
                        display: inline-block;
                        min-width: 120px;
                    " onclick="handleButtonClick(${module.id}, 'primary')">${module.primaryBtn}</a>
                </div>
            </div>
        </div>
    `;

    return section;
}

// 设置滚动监听
function setupScrollListener() {
    let ticking = false;
    let lastScrollTime = 0;
    const scrollCooldown = 500; // 滚动冷却时间
    let lastVisibleIndex = -1;  // 记录上一次可见的卡片索引

    function updateOnScroll() {
        const now = Date.now();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        let mostVisibleSection = null;
        let maxVisibility = 0;

        // 找出最清晰可见的模块
        modules.forEach((module, index) => {
            const section = document.getElementById(`module-section-${module.id}`);
            if (section) {
                const rect = section.getBoundingClientRect();
                // 计算可见度得分
                const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
                const visibilityScore = visibleHeight > 0 ? visibleHeight / section.offsetHeight : 0;

                if (visibilityScore > maxVisibility) {
                    maxVisibility = visibilityScore;
                    mostVisibleSection = { module, index, visibilityScore };
                }
            }
        });

        // 只有当最清晰可见的模块改变时才触发切换
        if (mostVisibleSection && mostVisibleSection.index !== lastVisibleIndex &&
            mostVisibleSection.visibilityScore > 0.5) { // 确保模块至少有50%可见

            const { module, index } = mostVisibleSection;

            // 检查是否可以切换场景
            if (now - lastScrollTime >= scrollCooldown &&
                typeof window.TimelineControl !== 'undefined' &&
                window.TimelineControl.jumpToCard) {

                lastVisibleIndex = index;
                currentModuleIndex = index;

                // 更新显示
                showScrollNotification(module);
                updateCurrentCardDisplay();
                updateStatusBarTitle(index);

                // 执行场景切换
                if (sceneTransitionManager.canTransition(index)) {
                    console.log(`🎬 滚动触发场景切换到卡片 ${index + 1}`);
                    sceneTransitionManager.startTransition(index);

                    const jumpResult = window.TimelineControl.jumpToCard(index, true);
                    if (jumpResult) {
                        console.log(`✅ Timeline跳转成功 - 卡片 ${index + 1}`);
                        lastScrollTime = now;

                        setTimeout(() => {
                            if (window.TimelineControl && window.TimelineControl.current) {
                                const currentInfo = window.TimelineControl.current();
                                if (currentInfo) {
                                    console.log(`🎯 Timeline状态确认:`, currentInfo);
                                }
                            }
                            sceneTransitionManager.endTransition();
                        }, 1500);
                    } else {
                        console.warn(`⚠️ Timeline跳转失败 - 卡片 ${index + 1}`);
                        sceneTransitionManager.endTransition();
                    }
                }
            }
        }

        ticking = false;
    }

    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateOnScroll);
            ticking = true;
        }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    console.log("✅ 滚动监听已设置");
}

// 显示滚动通知
function showScrollNotification(module) {
    // 移除现有通知
    const existingNotification = document.querySelector('.scroll-notification');
    if (existingNotification) {
        existingNotification.remove();
    }

    // 创建新通知
    const notification = document.createElement('div');
    notification.className = 'scroll-notification';
    notification.style.cssText = `
        position: fixed;
        top: 100px;
        right: 30px;
        background: linear-gradient(135deg, 
            rgba(255, 255, 255, 0.2) 0%, 
            rgba(255, 255, 255, 0.1) 100%);
        backdrop-filter: blur(20px) saturate(200%);
        -webkit-backdrop-filter: blur(20px) saturate(200%);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 16px;
        padding: 16px 20px;
        color: white;
        font-size: 14px;
        font-weight: 500;
        z-index: 1000;
        opacity: 0;
        transform: translateX(100px);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        pointer-events: auto;
        cursor: pointer;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
        max-width: 280px;
    `;

    notification.innerHTML = `
        <div style="font-weight: 600; margin-bottom: 4px; color: ${module.theme};">
            ${module.title}
        </div>
        <div style="font-size: 12px; opacity: 0.8;">
            ${module.subtitle}
        </div>
    `;

    // 点击通知滚动到对应模块
    notification.addEventListener('click', () => {
        const targetSection = document.getElementById(`module-section-${module.id}`);
        if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        notification.remove();
    });

    document.body.appendChild(notification);

    // 显示动画
    setTimeout(() => {
        notification.style.opacity = '1';
        notification.style.transform = 'translateX(0)';
    }, 100);

    // 自动隐藏
    setTimeout(() => {
        if (notification.parentNode) {
            notification.style.opacity = '0';
            notification.style.transform = 'translateX(100px)';
            setTimeout(() => {
                if (notification.parentNode) {
                    notification.remove();
                }
            }, 400);
        }
    }, 3000);
}

// 处理按钮点击
function handleButtonClick(moduleId, type) {
    const module = modules.find(m => m.id === moduleId);
    if (!module) return;

    console.log(`🔘 ${type} 按钮点击:`, module.title);

    // 模块主按钮跳转到对应的详情页
    if (type === 'primary') {
        const pageMap = {
            1: 'pages/modules/simulation-base.html',  // 数字孪生决策沙盘
            2: 'pages/modules/digital-twin-manufacturing.html',  // 智能产线监控系统
            3: 'pages/modules/metaverse-education.html',  // 元宇宙互动教学平台
            4: 'pages/modules/ai-digital-assistant.html',  // AI多角色训练助手
            5: 'pages/modules/xr-enterprise-training.html',  // XR企业教育实训
            6: 'pages/modules/vr-cloud-showroom.html',  // VR全景工厂展厅
            7: 'pages/modules/virtual-simulation-base.html',  // 虚拟仿真实训基地建设
            8: 'index.html#about',  // 关于我们
            9: 'index.html#contact' // 联系我们
        };

        if (pageMap[moduleId]) {
            console.log(`🚀 跳转到${module.title}详情页`);
            window.location.href = pageMap[moduleId];
            return;
        }

        // 其他模块的主按钮逻辑
        console.log(`执行主要操作: ${module.primaryBtn}`);
    } else {
        // 🎯 次按钮 - 跳转到对应卡片并同步Timeline（增强版）
        if (type === 'secondary') {
            const cardIndex = moduleId - 1; // 转换为0-based索引

            // 🛡️ 检查场景切换状态
            if (!sceneTransitionManager.canTransition(cardIndex)) {
                // 如果不能立即切换，添加到等待队列
                sceneTransitionManager.addPendingTransition(cardIndex, () => {
                    performSecondaryButtonAction(moduleId, module);
                });

                // 显示等待反馈
                showWaitingFeedback(module);
                return;
            }

            // 🎬 开始场景切换状态管理
            sceneTransitionManager.startTransition(cardIndex);

            // 执行实际的跳转操作
            performSecondaryButtonAction(moduleId, module);

            return;
        }

        // 其他次按钮逻辑
        console.log(`执行次要操作: ${module.secondaryBtn}`);
    }

    // 显示操作反馈
    showActionFeedback(module, type);
}

// 🎯 执行次按钮的实际操作
function performSecondaryButtonAction(moduleId, module) {
    console.log(`🎬 跳转到卡片 ${moduleId} 并同步Timeline`);

    // 使用全局跳转函数
    if (typeof window.TimelineControl !== 'undefined' && window.TimelineControl.jumpToCard) {
        const cardIndex = moduleId - 1;
        const jumpResult = window.TimelineControl.jumpToCard(cardIndex, true);

        if (jumpResult) {
            console.log(`✅ Timeline跳转成功 - 卡片 ${moduleId}`);

            // 📜 滚动到目标模块
            const targetElement = document.getElementById(`module-section-${moduleId}`);
            if (targetElement) {
                const navbar = document.querySelector('.navbar');
                const navbarHeight = navbar ? navbar.offsetHeight : 80;
                const targetTop = targetElement.offsetTop - navbarHeight - 20;

                window.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });

                console.log(`📜 滚动到模块 ${moduleId} 位置: ${targetTop}px`);
            }

            // 🎯 监听Timeline状态，确认切换完成
            setTimeout(() => {
                if (window.TimelineControl && window.TimelineControl.current) {
                    const currentInfo = window.TimelineControl.current();
                    if (currentInfo) {
                        console.log(`🎯 Timeline状态确认:`, currentInfo);
                    }
                }
                // 结束场景切换状态
                sceneTransitionManager.endTransition();
            }, 1500);

        } else {
            console.warn(`⚠️ Timeline跳转失败 - 模块 ${moduleId}，使用备用滚动`);
            // 备用方案
            const targetElement = document.getElementById(`module-section-${moduleId}`);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
            // 即使失败也要结束切换状态
            setTimeout(() => {
                sceneTransitionManager.endTransition();
            }, 1000);
        }
    } else {
        console.warn("⚠️ Timeline控制不可用，使用备用跳转方法");

        const targetElement = document.getElementById(`module-section-${moduleId}`);
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            console.log(`📜 备用滚动到模块 ${moduleId}`);
        }

        // 结束切换状态
        setTimeout(() => {
            sceneTransitionManager.endTransition();
        }, 1000);
    }

    // 显示操作反馈
    showActionFeedback(module, 'secondary');
}

// 🕐 显示等待反馈
function showWaitingFeedback(module) {
    const feedback = document.createElement('div');
    feedback.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(135deg, 
            rgba(255, 165, 0, 0.9) 0%, 
            rgba(255, 140, 0, 0.9) 100%);
        color: white;
        padding: 20px 30px;
        border-radius: 16px;
        font-size: 16px;
        font-weight: 500;
        z-index: 10000;
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.8);
        transition: all 0.3s ease;
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.2);
    `;

    feedback.innerHTML = `
        <div style="text-align: center;">
            <div style="font-size: 18px; margin-bottom: 8px;">⏳ 场景切换中...</div>
            <div style="font-size: 14px; opacity: 0.8;">请稍等，${module.title}</div>
        </div>
    `;

    document.body.appendChild(feedback);

    setTimeout(() => {
        feedback.style.opacity = '1';
        feedback.style.transform = 'translate(-50%, -50%) scale(1)';
    }, 100);

    setTimeout(() => {
        feedback.style.opacity = '0';
        feedback.style.transform = 'translate(-50%, -50%) scale(0.8)';
        setTimeout(() => feedback.remove(), 300);
    }, 1500);
}

// 显示操作反馈
function showActionFeedback(module, type) {
    const feedback = document.createElement('div');
    feedback.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(135deg, 
            rgba(0, 0, 0, 0.8) 0%, 
            rgba(0, 0, 0, 0.9) 100%);
        color: white;
        padding: 20px 30px;
        border-radius: 16px;
        font-size: 16px;
        font-weight: 500;
        z-index: 10000;
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.8);
        transition: all 0.3s ease;
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.2);
    `;

    const actionText = type === 'primary' ? module.primaryBtn : module.secondaryBtn;
    feedback.innerHTML = `
        <div style="text-align: center;">
            <div style="font-size: 18px; margin-bottom: 8px;">✨ ${actionText}</div>
            <div style="font-size: 14px; opacity: 0.8;">${module.title}</div>
        </div>
    `;

    document.body.appendChild(feedback);

    setTimeout(() => {
        feedback.style.opacity = '1';
        feedback.style.transform = 'translate(-50%, -50%) scale(1)';
    }, 100);

    setTimeout(() => {
        feedback.style.opacity = '0';
        feedback.style.transform = 'translate(-50%, -50%) scale(0.8)';
        setTimeout(() => feedback.remove(), 300);
    }, 2000);
}

// 滚动到指定模块
function scrollToModule(index) {
    if (index >= 0 && index < modules.length) {
        const targetSection = document.getElementById(`module-section-${modules[index].id}`);
        if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            currentModuleIndex = index;
        }
    }
}

// 添加动画样式
function addAnimationStyles() {
    const style = document.createElement('style');
    style.textContent = `
        /* 原有内容已从HTML中删除，不再需要隐藏规则 */
        
        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(50px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        @keyframes slideInLeft {
            from {
                opacity: 0;
                transform: translateX(-20px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }
        
        @keyframes slideInRight {
            from {
                opacity: 0;
                transform: translateX(20px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }
        
        @keyframes pulse {
            0%, 100% {
                transform: scale(1);
            }
            50% {
                transform: scale(1.05);
            }
        }
        
        @keyframes shimmer {
            0% {
                background-position: -200% 0;
            }
            100% {
                background-position: 200% 0;
            }
        }
        
        .glass-card:hover {
            background: linear-gradient(135deg, 
                rgba(255, 255, 255, 0.25) 0%, 
                rgba(255, 255, 255, 0.12) 100%);
            transform: translateY(-5px);
            box-shadow: 
                0 12px 40px rgba(0, 0, 0, 0.15),
                0 20px 60px rgba(0, 0, 0, 0.1),
                inset 0 1px 0 rgba(255, 255, 255, 0.5);
            border-color: rgba(255, 255, 255, 0.4);
        }
        
        .feature-tag:hover {
            animation: pulse 0.6s ease-in-out;
        }
        
         /* 按钮基础样式 - 重新设计 */
         .product-btn {
             transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
             will-change: transform, box-shadow, filter !important;
             position: relative !important;
             overflow: hidden !important;
         }
         
         /* 主按钮悬浮效果 - 统一样式 */
         .product-btn.primary:hover {
             transform: translateY(-4px) scale(1.02) !important;
             filter: brightness(1.15) saturate(1.2) !important;
             box-shadow: 
                 0 8px 25px rgba(0, 0, 0, 0.3),
                 0 4px 15px rgba(255, 255, 255, 0.1),
                 inset 0 1px 0 rgba(255, 255, 255, 0.3) !important;
         }
         
         /* 为每个模块的主按钮设置特定主题色阴影 */
         .btn-1-primary:hover { box-shadow: 0 8px 25px #667eea80, 0 4px 15px #667eea40, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-2-primary:hover { box-shadow: 0 8px 25px #764ba280, 0 4px 15px #764ba240, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-3-primary:hover { box-shadow: 0 8px 25px #f093fb80, 0 4px 15px #f093fb40, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-4-primary:hover { box-shadow: 0 8px 25px #667eea80, 0 4px 15px #667eea40, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-5-primary:hover { box-shadow: 0 8px 25px #764ba280, 0 4px 15px #764ba240, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-6-primary:hover { box-shadow: 0 8px 25px #f093fb80, 0 4px 15px #f093fb40, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-7-primary:hover { box-shadow: 0 8px 25px #667eea80, 0 4px 15px #667eea40, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-8-primary:hover { box-shadow: 0 8px 25px #764ba280, 0 4px 15px #764ba240, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         .btn-9-primary:hover { box-shadow: 0 8px 25px #f093fb80, 0 4px 15px #f093fb40, inset 0 1px 0 rgba(255, 255, 255, 0.3) !important; }
         
         /* 次按钮悬浮效果 - 增强版 */
         .product-btn.secondary:hover {
             background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%) !important;
             border-color: rgba(255, 255, 255, 0.5) !important;
             transform: translateY(-4px) scale(1.02) !important;
             box-shadow: 
                 0 8px 25px rgba(255, 255, 255, 0.2),
                 0 4px 15px rgba(255, 255, 255, 0.1),
                 inset 0 1px 0 rgba(255, 255, 255, 0.4) !important;
             backdrop-filter: blur(20px) saturate(200%) !important;
             -webkit-backdrop-filter: blur(20px) saturate(200%) !important;
         }
         
         /* 按钮按下效果 */
         .product-btn:active {
             transform: translateY(-1px) scale(0.98) !important;
             transition: all 0.1s ease !important;
         }
         
         /* 镜面反射光效 - 重新设计 */
         .product-btn::before {
             content: '';
             position: absolute;
             top: 0;
             left: -100%;
             width: 100%;
             height: 100%;
             background: linear-gradient(
                 90deg, 
                 transparent 0%, 
                 rgba(255, 255, 255, 0.1) 25%,
                 rgba(255, 255, 255, 0.3) 50%,
                 rgba(255, 255, 255, 0.1) 75%,
                 transparent 100%
             );
             transition: left 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
             z-index: 1;
         }
         
         .product-btn:hover::before {
             left: 100%;
         }
         
         /* 按钮文字层级 - 确保文字显示 */
         .product-btn {
             color: white !important;
             text-decoration: none !important;
         }
         
         .product-btn * {
             position: relative;
             z-index: 2;
             color: inherit !important;
         }
        
        /* 响应式设计 */
        @media (max-width: 768px) {
            .content-right {
                margin-right: 20px;
                margin-left: 20px;
                max-width: none;
            }
            
            .glass-card {
                padding: 24px !important;
            }
            
            .product-title {
                font-size: 22px !important;
            }
            
            .product-description {
                font-size: 14px !important;
            }
            
            .product-buttons {
                flex-direction: column;
                gap: 8px !important;
            }
            
            .scroll-notification {
                right: 15px !important;
                max-width: 240px !important;
            }
        }
        
        @media (max-width: 480px) {
            .content-section {
                padding: 120px 0 60px 0 !important;
            }
            
            .glass-card {
                padding: 20px !important;
                border-radius: 16px !important;
            }
            
            .product-title {
                font-size: 20px !important;
            }
            
            .product-subtitle {
                font-size: 14px !important;
            }
            
            .product-description {
                font-size: 13px !important;
                line-height: 1.5 !important;
            }
            
            .feature-tag {
                font-size: 11px !important;
                padding: 4px 8px !important;
            }
            
                         .product-btn {
                 font-size: 11px !important;
                 padding: 6px 12px !important;
                 min-width: 70px !important;
             }
        }
    `;
    document.head.appendChild(style);
}

// 模块保护机制 - 防止被其他脚本覆盖
let moduleProtectionInterval;
let mutationObserver;
let initializationAttempts = 0;
const MAX_INIT_ATTEMPTS = 10;
let isInitialized = false;

function protectModules() {
    // 检查模块是否还存在
    const moduleCount = document.querySelectorAll('[id^="module-section-"]').length;
    if (moduleCount < 9 && isInitialized) {
        console.warn(`⚠️ 检测到模块丢失，当前只有${moduleCount}个模块，立即重新初始化...`);
        setTimeout(() => {
            addModulesToExistingContainer();
        }, 100);
    }
}

function startDOMObserver() {
    // 使用 MutationObserver 监控 DOM 变化
    if (mutationObserver) {
        mutationObserver.disconnect();
    }

    mutationObserver = new MutationObserver((mutations) => {
        let needsRestore = false;

        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                // 检查是否有受保护的模块被删除
                mutation.removedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // 检查是否是受保护的模块
                        if ((node.id && node.id.startsWith('module-section-')) ||
                            (node.getAttribute && node.getAttribute('data-protected') === 'true') ||
                            (node.querySelector && node.querySelector('[id^="module-section-"]')) ||
                            (node.querySelector && node.querySelector('[data-protected="true"]'))) {
                            console.warn(`🚨 检测到受保护模块被删除: ${node.id || node.getAttribute('data-module-id') || '容器'}`);
                            needsRestore = true;
                        }
                    }
                });
            }
        });

        if (needsRestore) {
            console.log("🔄 DOM变化检测到模块丢失，准备恢复...");
            setTimeout(() => {
                const currentCount = document.querySelectorAll('[id^="module-section-"]').length;
                if (currentCount < 9) {
                    console.log(`📊 确认模块丢失 (${currentCount}/9)，立即恢复`);
                    addModulesToExistingContainer();
                }
            }, 50);
        }
    });

    // 监控整个文档的变化
    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // 额外保护：监控样式变化，防止被CSS隐藏
    const styleObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                const target = mutation.target;
                if (target.id && target.id.startsWith('module-section-')) {
                    // 检查是否被隐藏
                    const computedStyle = window.getComputedStyle(target);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || computedStyle.opacity === '0') {
                        console.warn(`🚨 模块${target.id}被CSS隐藏，强制恢复显示`);
                        target.style.display = 'flex';
                        target.style.visibility = 'visible';
                        target.style.opacity = '1';
                    }
                }
            }
        });
    });

    // 监控所有模块的样式变化
    setTimeout(() => {
        document.querySelectorAll('[id^="module-section-"]').forEach(module => {
            styleObserver.observe(module, {
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        });
    }, 1000);

    console.log("👁️ DOM变化监控已启动 (包含样式保护)");
}

function startModuleProtection() {
    // 启动定时检查
    moduleProtectionInterval = setInterval(protectModules, 2000);

    // 启动DOM监控
    startDOMObserver();

    console.log("🛡️ 模块保护机制已启动 (定时检查 + DOM监控)");
}

function stopModuleProtection() {
    if (moduleProtectionInterval) {
        clearInterval(moduleProtectionInterval);
        moduleProtectionInterval = null;
    }

    if (mutationObserver) {
        mutationObserver.disconnect();
        mutationObserver = null;
    }

    console.log("🛡️ 模块保护机制已停止");
}

// 早期清理函数 - 简化版（HTML已经是空的了）
function earlyCleanup() {
    console.log("🧹 检查是否有遗留内容需要清理...");

    // 只清理可能的遗留section（保险措施）
    const scrollContainer = document.querySelector('.scroll-container');
    if (scrollContainer) {
        const existingSections = scrollContainer.querySelectorAll('section');
        if (existingSections.length > 0) {
            console.log(`🗑️ 清理 ${existingSections.length} 个遗留section`);
            existingSections.forEach(section => {
                if (!section.id || !section.id.startsWith('module-section-')) {
                    section.remove();
                }
            });
        }
    }

    console.log("✅ 清理检查完成");
}

// 初始化函数 - 增强版
function init() {
    initializationAttempts++;
    console.log(`🚀 CompanyStyleModuleUI 初始化开始 (第${initializationAttempts}次尝试)`);

    // 立即执行早期清理
    earlyCleanup();

    // 等待DOM加载完成
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(init, 50); // 缩短延迟
        });
        return;
    }

    // 添加样式
    addAnimationStyles();

    // 🎛️ 初始化滚轮控制
    //initCustomWheelControl();

    // 🔧 启动调试诊断
    debugWheelControl();

    addStatusBarStyles();
    createStatusBar();

    // 立即尝试初始化，不等待
    const attemptInit = () => {
        // 再次清理，确保没有遗漏
        earlyCleanup();

        addModulesToExistingContainer();

        // 验证初始化是否成功
        setTimeout(() => {
            const moduleCount = document.querySelectorAll('[id^="module-section-"]').length;
            console.log(`📊 当前模块数量: ${moduleCount}/9`);

            if (moduleCount === 9) {
                console.log("✅ CompanyStyleModuleUI 初始化成功");
                isInitialized = true; // 标记为已初始化
                startModuleProtection(); // 启动保护机制

                // 强制检查所有模块的内容显示
                setTimeout(() => {
                    console.log("🔍 检查所有模块内容显示...");
                    modules.forEach(module => {
                        const section = document.getElementById(`module-section-${module.id}`);
                        if (section) {
                            // 检查并恢复标题
                            const title = section.querySelector('.product-title');
                            if (title) {
                                title.innerHTML = module.title;
                                title.style.setProperty('display', 'block', 'important');
                                title.style.setProperty('visibility', 'visible', 'important');
                                title.style.setProperty('opacity', '1', 'important');
                            }

                            // 检查并恢复副标题
                            const subtitle = section.querySelector('.product-subtitle');
                            if (subtitle) {
                                subtitle.innerHTML = module.subtitle;
                                subtitle.style.setProperty('display', 'block', 'important');
                                subtitle.style.setProperty('visibility', 'visible', 'important');
                                subtitle.style.setProperty('opacity', '1', 'important');
                            }

                            // 检查并恢复描述
                            const description = section.querySelector('.product-description');
                            if (description) {
                                description.innerHTML = module.description;
                                description.style.setProperty('display', 'block', 'important');
                                description.style.setProperty('visibility', 'visible', 'important');
                                description.style.setProperty('opacity', '1', 'important');
                                description.style.setProperty('height', 'auto', 'important');
                                description.style.setProperty('max-height', 'none', 'important');
                            }

                            // 检查并恢复功能特性
                            const features = section.querySelector('.product-features');
                            if (features) {
                                features.innerHTML = module.features.map(feature => `
                                    <span class="feature-tag" style="
                                        background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
                                        border: 1px solid rgba(255, 255, 255, 0.2);
                                        border-radius: 12px;
                                        padding: 6px 12px;
                                        font-size: 12px;
                                        font-weight: 500;
                                        color: rgba(255, 255, 255, 0.9) !important;
                                        text-align: center;
                                        transition: all 0.3s ease;
                                        cursor: pointer;
                                        position: relative;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        flex-shrink: 0;
                                        display: inline-block !important;
                                        visibility: visible !important;
                                        opacity: 1 !important;
                                        margin-right: 8px;
                                        margin-bottom: 8px;
                                    ">${feature}</span>
                                `).join('');
                                features.style.setProperty('display', 'flex', 'important');
                                features.style.setProperty('visibility', 'visible', 'important');
                                features.style.setProperty('opacity', '1', 'important');
                            }

                            console.log(`✅ 模块${module.id}内容已强制恢复: ${module.title}`);
                        }
                    });
                    console.log("✅ 所有模块内容已强制刷新");
                }, 500);

                // 额外的延迟检查，确保内容不会被后续脚本清理
                setTimeout(() => {
                    console.log("🔍 执行二次内容保护检查...");
                    [3, 6, 7].forEach(moduleId => {
                        const section = document.getElementById(`module-section-${moduleId}`);
                        const module = modules.find(m => m.id === moduleId);
                        if (section && module) {
                            const description = section.querySelector('.product-description');
                            const subtitle = section.querySelector('.product-subtitle');
                            const features = section.querySelector('.product-features');

                            if (description && (!description.textContent || description.textContent.trim().length < 50)) {
                                console.warn(`🚨 模块${moduleId}描述内容丢失，强制恢复`);
                                description.innerHTML = module.description;
                                description.style.setProperty('display', 'block', 'important');
                                description.style.setProperty('visibility', 'visible', 'important');
                                description.style.setProperty('opacity', '1', 'important');
                            }

                            if (subtitle && (!subtitle.textContent || subtitle.textContent.trim().length < 5)) {
                                console.warn(`🚨 模块${moduleId}副标题内容丢失，强制恢复`);
                                subtitle.innerHTML = module.subtitle;
                                subtitle.style.setProperty('display', 'block', 'important');
                                subtitle.style.setProperty('visibility', 'visible', 'important');
                                subtitle.style.setProperty('opacity', '1', 'important');
                            }

                            if (features && features.children.length < module.features.length) {
                                console.warn(`🚨 模块${moduleId}功能特性丢失，强制恢复`);
                                features.innerHTML = module.features.map(feature => `
                                    <span class="feature-tag" style="
                                        background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
                                        border: 1px solid rgba(255, 255, 255, 0.2);
                                        border-radius: 12px;
                                        padding: 6px 12px;
                                        font-size: 12px;
                                        font-weight: 500;
                                        color: rgba(255, 255, 255, 0.9) !important;
                                        display: inline-block !important;
                                        visibility: visible !important;
                                        opacity: 1 !important;
                                        margin-right: 8px;
                                        margin-bottom: 8px;
                                    ">${feature}</span>
                                `).join('');
                            }
                        }
                    });
                    console.log("✅ 二次内容保护检查完成");
                }, 2000);

            } else if (initializationAttempts < MAX_INIT_ATTEMPTS) {
                console.warn(`⚠️ 初始化不完整，${2000}ms后重试...`);
                setTimeout(attemptInit, 2000);
            } else {
                console.error("❌ 初始化失败，已达到最大重试次数");
            }
        }, 1000);
    };

    // 立即初始化，不等待其他组件
    attemptInit();

    // 初始化场景缓存
    console.log("📦 初始化场景缓存系统");
}

// 导出函数供外部使用
window.CompanyStyleModuleUI = {
    init,
    scrollToModule,
    modules,
    startProtection: startModuleProtection,
    stopProtection: stopModuleProtection,
    forceRefresh: () => {
        console.log("🔄 强制刷新模块...");
        isInitialized = false; // 重置初始化状态
        addModulesToExistingContainer();
    },
    getStatus: () => {
        const moduleCount = document.querySelectorAll('[id^="module-section-"]').length;
        return {
            initialized: isInitialized,
            moduleCount: moduleCount,
            expected: 9,
            complete: moduleCount === 9
        };
    },
    emergencyRestore: () => {
        console.log("🚨 紧急恢复模块...");
        stopModuleProtection();
        isInitialized = false;
        initializationAttempts = 0;
        setTimeout(() => {
            init();
        }, 100);
    }
};

// 立即执行早期清理
if (document.readyState !== 'loading') {
    earlyCleanup();
}

// 自动初始化
init();

// 额外的早期清理，在脚本加载后立即执行
setTimeout(() => {
    earlyCleanup();
    console.log("🧹 额外早期清理完成");
}, 100);

console.log("✅ CompanyStyleModuleUI 9个模块脚本加载完成");

// 🎯 用户使用说明
setTimeout(() => {
    console.log("");
    console.log("🎛️ ===== 滚轮速度控制使用说明 =====");
    console.log("📌 如果左上角没有显示控制面板，请在控制台输入：");
    console.log("   WheelDebug.showPanel()");
    console.log("");
    console.log("🧪 测试滚轮控制是否工作：");
    console.log("   WheelDebug.testScroll(100)");
    console.log("");
    console.log("🔧 强制启用滚轮控制：");
    console.log("   WheelDebug.forceEnable()");
    console.log("");
    console.log("📊 查看当前配置：");
    console.log("   WheelDebug.getConfig()");
    console.log("");
    console.log("🎮 或者直接使用：");
    console.log("   ScrollWheelControl.setSpeed(1.5)  // 设置速度");
    console.log("   ScrollWheelControl.toggle(true)   // 启用控制");
    console.log("🎛️ =====================================");
    console.log("");

    // 添加强制恢复原生滚动的全局命令
    window.ForceNativeScroll = function () {
        // 移除所有可能的自定义滚轮监听器
        document.removeEventListener('wheel', handleCustomWheel);

        // 移除轻量级滚动控制
        const listeners = document._wheelListeners || [];
        listeners.forEach(listener => {
            document.removeEventListener('wheel', listener);
        });

        // 移除控制面板
        const panel = document.getElementById('scroll-control-panel');
        if (panel) {
            panel.remove();
            console.log("🗑️ 已移除滚轮控制面板");
        }

        // 确保scrollConfig被禁用
        scrollConfig.enabled = false;

        // 清理任何可能的滚动状态
        if (wheelControlState.rafId) {
            cancelAnimationFrame(wheelControlState.rafId);
            wheelControlState.rafId = null;
        }
        wheelControlState.accumulatedDelta = 0;

        console.log("✅ 强制恢复100%原生滚动完成！");
        console.log("🎯 现在使用浏览器默认滚动速度");
    };

    // 添加滚动速度控制命令
    window.ScrollSpeedControl = {
        // 设置为50%速度（当前默认）
        setSlow: function () {
            //initCustomWheelControl();
            console.log("🐌 滚动速度已设置为50%（减速模式）");
        },

        // 恢复100%原生速度
        setNormal: function () {
            ForceNativeScroll();
            console.log("🏃 滚动速度已恢复为100%（原生模式）");
        },

        // 自定义速度（0.1-2.0）
        setCustom: function (speed = 0.5) {
            speed = Math.max(0.1, Math.min(2.0, speed));

            // 移除现有监听器
            document.removeEventListener('wheel', handleCustomWheel);

            // 添加自定义速度控制
            function customSpeedControl(event) {
                event.preventDefault();
                const adjustedDelta = event.deltaY * speed;
                window.scrollBy({
                    top: adjustedDelta,
                    behavior: 'auto'
                });
            }

            document.addEventListener('wheel', customSpeedControl, { passive: false });
            console.log(`⚡ 滚动速度已设置为${(speed * 100).toFixed(0)}%`);
        },

        // 获取当前状态
        getStatus: function () {
            console.log("📊 滚动速度控制状态:");
            console.log("   当前模式: 50%减速模式");
            console.log("   可用命令:");
            console.log("   - ScrollSpeedControl.setSlow()    // 50%速度");
            console.log("   - ScrollSpeedControl.setNormal()  // 100%速度");
            console.log("   - ScrollSpeedControl.setCustom(0.3) // 自定义速度");
        }
    };

}, 3000);

// 🎛️ 动态滚轮速度调节器 - 简化版
setTimeout(() => {
    console.log("");
    console.log("🎛️ ===== 动态滚轮速度调节器 =====");
    console.log("🎯 快速调节命令（立即生效）：");
    console.log("");
    console.log("⚡ 常用速度预设：");
    console.log("   ScrollSpeedControl.setCustom(0.2)  // 20% - 非常慢");
    console.log("   ScrollSpeedControl.setCustom(0.3)  // 30% - 很慢");
    console.log("   ScrollSpeedControl.setCustom(0.5)  // 50% - 慢");
    console.log("   ScrollSpeedControl.setCustom(0.7)  // 70% - 稍慢");
    console.log("   ScrollSpeedControl.setCustom(1.0)  // 100% - 原生");
    console.log("   ScrollSpeedControl.setCustom(1.5)  // 150% - 快");
    console.log("");
    console.log("🔧 精确调节（0.1-2.0）：");
    console.log("   ScrollSpeedControl.setCustom(0.4)  // 40%");
    console.log("   ScrollSpeedControl.setCustom(0.6)  // 60%");
    console.log("   ScrollSpeedControl.setCustom(0.8)  // 80%");
    console.log("");

    // 添加快捷命令
    window.Speed = {
        // 预设速度
        verySlow: () => ScrollSpeedControl.setCustom(0.2),
        slow: () => ScrollSpeedControl.setCustom(0.3),
        medium: () => ScrollSpeedControl.setCustom(0.5),
        normal: () => ScrollSpeedControl.setCustom(1.0),
        fast: () => ScrollSpeedControl.setCustom(1.5),

        // 微调命令
        up: () => {
            const current = window.currentScrollSpeed || 0.5;
            const newSpeed = Math.min(2.0, current + 0.1);
            ScrollSpeedControl.setCustom(newSpeed);
            window.currentScrollSpeed = newSpeed;
        },

        down: () => {
            const current = window.currentScrollSpeed || 0.5;
            const newSpeed = Math.max(0.1, current - 0.1);
            ScrollSpeedControl.setCustom(newSpeed);
            window.currentScrollSpeed = newSpeed;
        },

        // 获取当前速度
        current: () => {
            console.log(`当前滚动速度: ${(window.currentScrollSpeed || 0.5) * 100}%`);
            return window.currentScrollSpeed || 0.5;
        },

        // 测试不同速度
        test: () => {
            console.log("🧪 开始速度测试序列...");
            const speeds = [0.2, 0.3, 0.5, 0.7, 1.0];
            let index = 0;

            const testNext = () => {
                if (index < speeds.length) {
                    const speed = speeds[index];
                    ScrollSpeedControl.setCustom(speed);
                    console.log(`🎯 测试速度 ${(speed * 100)}% - 请滚动测试，5秒后自动切换到下一个速度`);
                    index++;
                    setTimeout(testNext, 5000);
                } else {
                    console.log("✅ 速度测试完成！请选择您喜欢的速度");
                    console.log("💡 使用 Speed.medium() 或 ScrollSpeedControl.setCustom(0.5) 设置");
                }
            };

            testNext();
        }
    };

    console.log("🎮 快捷命令已添加：");
    console.log("   Speed.verySlow()  // 20%");
    console.log("   Speed.slow()      // 30%");
    console.log("   Speed.medium()    // 50%");
    console.log("   Speed.normal()    // 100%");
    console.log("   Speed.fast()      // 150%");
    console.log("");
    console.log("🔧 微调命令：");
    console.log("   Speed.up()        // 增加10%");
    console.log("   Speed.down()      // 减少10%");
    console.log("   Speed.current()   // 查看当前速度");
    console.log("   Speed.test()      // 自动测试多个速度");
    console.log("");
    console.log("🎛️ ===================================");

    // 初始化当前速度
    window.currentScrollSpeed = 0.5;

}, 4000);

// 🎛️ 创建可视化滚轮速度调试UI窗口
function createScrollSpeedDebugUI() {
    // 检查是否已存在
    if (document.getElementById('scroll-speed-debug-ui')) {
        return;
    }

    const debugUI = document.createElement('div');
    debugUI.id = 'scroll-speed-debug-ui';
    debugUI.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        width: 320px;
        background: linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(20, 20, 20, 0.95) 100%);
        backdrop-filter: blur(20px) saturate(200%);
        -webkit-backdrop-filter: blur(20px) saturate(200%);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 16px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        color: white;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        z-index: 99999;
        padding: 0;
        overflow: hidden;
        transition: all 0.3s ease;
        user-select: none;
    `;

    debugUI.innerHTML = `
        <!-- 标题栏 -->
        <div style="
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            padding: 12px 16px;
            font-weight: 600;
            font-size: 16px;
        display: flex;
            justify-content: space-between;
        align-items: center;
            cursor: move;
        " id="debug-ui-header">
            <span>🎛️ 滚轮速度调试器</span>
            <div style="display: flex; gap: 8px;">
                <button id="minimize-btn" style="
                    background: rgba(255, 255, 255, 0.2);
                    border: none;
                    color: white;
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 12px;
                ">−</button>
                <button id="close-btn" style="
                    background: rgba(255, 0, 0, 0.6);
                    border: none;
                    color: white;
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 12px;
                ">×</button>
            </div>
        </div>
        
        <!-- 内容区域 -->
        <div id="debug-ui-content" style="padding: 16px;">
            <!-- 当前状态显示 -->
            <div style="
                background: rgba(255, 255, 255, 0.05);
                border-radius: 8px;
                padding: 12px;
                margin-bottom: 16px;
                text-align: center;
            ">
                <div style="font-size: 12px; opacity: 0.7; margin-bottom: 4px;">当前滚动速度</div>
                <div id="current-speed-display" style="
                    font-size: 24px;
                        font-weight: 700;
                    color: #4CAF50;
                ">50%</div>
                </div>
                
            <!-- 快速预设按钮 -->
            <div style="margin-bottom: 16px;">
                <div style="font-size: 12px; opacity: 0.8; margin-bottom: 8px;">⚡ 快速预设</div>
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px;">
                    <button class="speed-preset-btn" data-speed="0.2" style="
                        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
                        border: none;
                        color: white;
                        padding: 8px 12px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 12px;
                        font-weight: 500;
                        transition: all 0.2s ease;
                    ">20% 很慢</button>
                    
                    <button class="speed-preset-btn" data-speed="0.3" style="
                        background: linear-gradient(135deg, #ffa726 0%, #ff9800 100%);
                        border: none;
                        color: white;
                        padding: 8px 12px;
                        border-radius: 8px;
                        cursor: pointer;
                            font-size: 12px;
                            font-weight: 500;
                        transition: all 0.2s ease;
                    ">30% 慢</button>
                    
                    <button class="speed-preset-btn" data-speed="0.5" style="
                        background: linear-gradient(135deg, #66bb6a 0%, #4caf50 100%);
                        border: none;
                        color: white;
                        padding: 8px 12px;
                        border-radius: 8px;
                            cursor: pointer;
                        font-size: 12px;
                        font-weight: 500;
                        transition: all 0.2s ease;
                    ">50% 中等</button>
                    
                    <button class="speed-preset-btn" data-speed="0.7" style="
                        background: linear-gradient(135deg, #42a5f5 0%, #2196f3 100%);
                        border: none;
                        color: white;
                        padding: 8px 12px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 12px;
                        font-weight: 500;
                        transition: all 0.2s ease;
                    ">70% 稍快</button>
                    
                    <button class="speed-preset-btn" data-speed="1.0" style="
                        background: linear-gradient(135deg, #ab47bc 0%, #9c27b0 100%);
                        border: none;
                        color: white;
                        padding: 8px 12px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 12px;
                        font-weight: 500;
                        transition: all 0.2s ease;
                    ">100% 原生</button>
                    
                    <button class="speed-preset-btn" data-speed="1.5" style="
                        background: linear-gradient(135deg, #5c6bc0 0%, #3f51b5 100%);
                        border: none;
                        color: white;
                        padding: 8px 12px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 12px;
                        font-weight: 500;
                        transition: all 0.2s ease;
                    ">150% 快</button>
                </div>
                </div>
                
            <!-- 精确调节滑块 -->
            <div style="margin-bottom: 16px;">
                <div style="font-size: 12px; opacity: 0.8; margin-bottom: 8px;">🔧 精确调节</div>
                <div style="
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 8px;
                    padding: 12px;
                ">
                    <input type="range" id="speed-slider" min="0.1" max="2.0" step="0.1" value="0.5" style="
                        width: 100%;
                        height: 6px;
                        background: linear-gradient(90deg, #ff6b6b 0%, #ffa726 25%, #66bb6a 50%, #42a5f5 75%, #ab47bc 100%);
                        border-radius: 3px;
                        outline: none;
                        -webkit-appearance: none;
                        cursor: pointer;
                    ">
                    <div style="
                    display: flex;
                        justify-content: space-between;
                        font-size: 10px;
                        opacity: 0.6;
                        margin-top: 4px;
                    ">
                        <span>0.1</span>
                        <span>1.0</span>
                        <span>2.0</span>
                    </div>
                </div>
            </div>
            
            <!-- 微调按钮 -->
            <div style="margin-bottom: 16px;">
                <div style="font-size: 12px; opacity: 0.8; margin-bottom: 8px;">⏫ 微调 (±10%)</div>
                <div style="display: flex; gap: 8px;">
                    <button id="speed-down-btn" style="
                        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        color: white;
                        padding: 8px 16px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 12px;
                        font-weight: 500;
                        flex: 1;
                        transition: all 0.2s ease;
                    ">− 减速</button>
                    
                    <button id="speed-up-btn" style="
                        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        color: white;
                        padding: 8px 16px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-size: 12px;
                        font-weight: 500;
                        flex: 1;
                        transition: all 0.2s ease;
                    ">+ 加速</button>
                </div>
            </div>
            
            <!-- 测试功能 -->
            <div style="margin-bottom: 16px;">
                <div style="font-size: 12px; opacity: 0.8; margin-bottom: 8px;">🧪 自动测试</div>
                <button id="auto-test-btn" style="
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border: none;
                    color: white;
                    padding: 10px;
                    border-radius: 8px;
                    cursor: pointer;
                    font-size: 12px;
                    font-weight: 500;
                    width: 100%;
                    transition: all 0.2s ease;
                ">开始速度测试 (5种速度)</button>
        </div>
            
            <!-- 重置按钮 -->
            <div>
                <button id="reset-native-btn" style="
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
        border: 1px solid rgba(255, 255, 255, 0.3);
        color: white;
                    padding: 8px;
                    border-radius: 8px;
        cursor: pointer;
                    font-size: 11px;
                    font-weight: 500;
                    width: 100%;
                    transition: all 0.2s ease;
                ">🔄 恢复原生滚动 (100%)</button>
        </div>
        </div>
    `;

    document.body.appendChild(debugUI);

    // 绑定事件
    setupDebugUIEvents(debugUI);

    // 使窗口可拖拽
    makeDebugUIDraggable(debugUI);

    console.log("✅ 滚轮速度调试UI已创建");
}

// 设置调试UI事件
function setupDebugUIEvents(debugUI) {
    const currentSpeedDisplay = debugUI.querySelector('#current-speed-display');
    const speedSlider = debugUI.querySelector('#speed-slider');
    const presetButtons = debugUI.querySelectorAll('.speed-preset-btn');
    const speedUpBtn = debugUI.querySelector('#speed-up-btn');
    const speedDownBtn = debugUI.querySelector('#speed-down-btn');
    const autoTestBtn = debugUI.querySelector('#auto-test-btn');
    const resetNativeBtn = debugUI.querySelector('#reset-native-btn');
    const minimizeBtn = debugUI.querySelector('#minimize-btn');
    const closeBtn = debugUI.querySelector('#close-btn');
    const content = debugUI.querySelector('#debug-ui-content');

    let currentSpeed = 0.5;

    // 更新显示
    function updateSpeedDisplay(speed) {
        currentSpeed = speed;
        window.currentScrollSpeed = speed;
        currentSpeedDisplay.textContent = `${Math.round(speed * 100)}%`;
        speedSlider.value = speed;

        // 更新颜色
        if (speed <= 0.3) {
            currentSpeedDisplay.style.color = '#ff6b6b';
        } else if (speed <= 0.6) {
            currentSpeedDisplay.style.color = '#ffa726';
        } else if (speed <= 0.8) {
            currentSpeedDisplay.style.color = '#66bb6a';
        } else if (speed <= 1.2) {
            currentSpeedDisplay.style.color = '#42a5f5';
        } else {
            currentSpeedDisplay.style.color = '#ab47bc';
        }
    }

    // 预设按钮
    presetButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const speed = parseFloat(btn.dataset.speed);
            ScrollSpeedControl.setCustom(speed);
            updateSpeedDisplay(speed);

            // 按钮点击效果
            btn.style.transform = 'scale(0.95)';
            setTimeout(() => {
                btn.style.transform = 'scale(1)';
            }, 150);
        });

        // 悬浮效果
        btn.addEventListener('mouseenter', () => {
            btn.style.transform = 'translateY(-2px)';
            btn.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
        });

        btn.addEventListener('mouseleave', () => {
            btn.style.transform = 'translateY(0)';
            btn.style.boxShadow = 'none';
        });
    });

    // 滑块
    speedSlider.addEventListener('input', (e) => {
        const speed = parseFloat(e.target.value);
        ScrollSpeedControl.setCustom(speed);
        updateSpeedDisplay(speed);
    });

    // 微调按钮
    speedUpBtn.addEventListener('click', () => {
        const newSpeed = Math.min(2.0, currentSpeed + 0.1);
        ScrollSpeedControl.setCustom(newSpeed);
        updateSpeedDisplay(newSpeed);
    });

    speedDownBtn.addEventListener('click', () => {
        const newSpeed = Math.max(0.1, currentSpeed - 0.1);
        ScrollSpeedControl.setCustom(newSpeed);
        updateSpeedDisplay(newSpeed);
    });

    // 自动测试
    autoTestBtn.addEventListener('click', () => {
        autoTestBtn.textContent = '测试进行中...';
        autoTestBtn.disabled = true;

        const speeds = [0.2, 0.3, 0.5, 0.7, 1.0];
        let index = 0;

        const testNext = () => {
            if (index < speeds.length) {
                const speed = speeds[index];
                ScrollSpeedControl.setCustom(speed);
                updateSpeedDisplay(speed);

                autoTestBtn.textContent = `测试 ${Math.round(speed * 100)}% (${5 - index}s)`;

                let countdown = 5;
                const countdownTimer = setInterval(() => {
                    countdown--;
                    if (countdown > 0) {
                        autoTestBtn.textContent = `测试 ${Math.round(speed * 100)}% (${countdown}s)`;
                    } else {
                        clearInterval(countdownTimer);
                        index++;
                        testNext();
                    }
                }, 1000);
            } else {
                autoTestBtn.textContent = '测试完成！';
                setTimeout(() => {
                    autoTestBtn.textContent = '开始速度测试 (5种速度)';
                    autoTestBtn.disabled = false;
                }, 2000);
            }
        };

        testNext();
    });

    // 重置原生
    resetNativeBtn.addEventListener('click', () => {
        ScrollSpeedControl.setNormal();
        updateSpeedDisplay(1.0);

        resetNativeBtn.textContent = '✅ 已恢复原生滚动';
        setTimeout(() => {
            resetNativeBtn.textContent = '🔄 恢复原生滚动 (100%)';
        }, 2000);
    });

    // 最小化
    let isMinimized = false;
    minimizeBtn.addEventListener('click', () => {
        isMinimized = !isMinimized;
        if (isMinimized) {
            content.style.display = 'none';
            debugUI.style.height = 'auto';
            minimizeBtn.textContent = '+';
        } else {
            content.style.display = 'block';
            minimizeBtn.textContent = '−';
        }
    });

    // 关闭
    closeBtn.addEventListener('click', () => {
        debugUI.remove();
    });

    // 初始化显示
    updateSpeedDisplay(currentSpeed);
}

// 使调试UI可拖拽
function makeDebugUIDraggable(debugUI) {
    const header = debugUI.querySelector('#debug-ui-header');
    let isDragging = false;
    let startX, startY, startLeft, startTop;

    header.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        startY = e.clientY;
        startLeft = debugUI.offsetLeft;
        startTop = debugUI.offsetTop;

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        debugUI.style.cursor = 'grabbing';
        header.style.cursor = 'grabbing';
    });

    function handleMouseMove(e) {
        if (!isDragging) return;

        const deltaX = e.clientX - startX;
        const deltaY = e.clientY - startY;

        let newLeft = startLeft + deltaX;
        let newTop = startTop + deltaY;

        // 限制在窗口内
        newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - debugUI.offsetWidth));
        newTop = Math.max(0, Math.min(newTop, window.innerHeight - debugUI.offsetHeight));

        debugUI.style.left = newLeft + 'px';
        debugUI.style.top = newTop + 'px';
        debugUI.style.right = 'auto';
    }

    function handleMouseUp() {
        isDragging = false;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);

        debugUI.style.cursor = 'default';
        header.style.cursor = 'move';
    }
}

//// 在初始化完成后创建调试UI
//setTimeout(() => {
//    createScrollSpeedDebugUI();
//}, 5000);

// 自动初始化 - 确保模块在加载后自动启动
console.log("🎨 CompanyStyleModuleUI 文件加载完成，开始自动初始化...");

// 确保在DOM准备就绪后初始化
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    // DOM已经准备就绪，立即初始化
    setTimeout(init, 100);
}

// 创建状态栏
function createStatusBar() {
    const statusBar = document.createElement('div');
    statusBar.className = 'needle-status-bar';

    const title = document.createElement('div');
    title.className = 'needle-logo';
    title.textContent = modules[0]?.title || 'YF科技';

    statusBar.appendChild(title);
    document.body.appendChild(statusBar);

    window.statusBarElement = statusBar;
    window.statusBarTitle = title;

    // 初始化颜色
    updateStatusBarColor(0);

    return statusBar;
}

// 添加状态栏样式
function addStatusBarStyles() {
    const styles = `
        .needle-status-bar {
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 20px;
            border-radius: 20px;
            z-index: 1000;
            width: 405px;
            height: 48px;
            margin-bottom: 30px;
            border: 1px solid rgba(255, 255, 255, 0.25);
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            overflow: hidden;
            box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
        }

        .needle-status-bar::before {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: linear-gradient(
                45deg,
                transparent 0%,
                rgba(255, 255, 255, 0.1) 45%,
                rgba(255, 255, 255, 0.2) 50%,
                rgba(255, 255, 255, 0.1) 55%,
                transparent 100%
            );
            transform: translateX(-100%);
            animation: reflectAnimation 5s infinite linear;
            pointer-events: none;
        }

        @keyframes reflectAnimation {
            0% {
                transform: translateX(-100%) rotate(0deg);
            }
            100% {
                transform: translateX(100%) rotate(0deg);
            }
        }

        .needle-logo {
            font-size: 14px;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
            font-weight: 500;
            letter-spacing: 0.2px;
            color: rgba(255, 255, 255, 0.95);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
    `;

    const styleSheet = document.createElement('style');
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
}

// 更新状态栏标题和颜色
function updateStatusBarTitle(moduleIndex) {
    if (window.statusBarTitle && modules[moduleIndex]) {
        window.statusBarTitle.textContent = modules[moduleIndex].title;
        updateStatusBarColor(moduleIndex);
    }
}

// 🎨 更新状态栏背景色
function updateStatusBarColor(moduleIndex) {
    if (!window.statusBarElement) return;

    const colorIndex = Math.min(moduleIndex, cardColors.length - 1);
    const backgroundColor = cardColors[colorIndex];

    // 提取RGB值
    const [r, g, b] = backgroundColor.match(/\d+/g).map(Number);

    // 计算HSL值以调整饱和度和亮度
    const hsl = rgbToHsl(r, g, b);
    const adjustedRgb = hslToRgb(
        hsl[0],                    // 保持原色相
        Math.min(hsl[1] * 1.2, 1), // 增加饱和度
        Math.min(hsl[2] * 1.1, 1)  // 略微提高亮度
    );

    // 更新背景色为调整后的颜色
    window.statusBarElement.style.background = `rgb(${adjustedRgb[0]}, ${adjustedRgb[1]}, ${adjustedRgb[2]})`;

    // 文字保持白色
    if (window.statusBarTitle) {
        window.statusBarTitle.style.color = 'rgba(255, 255, 255, 0.95)';
    }

    console.log(`🎨 状态栏颜色已更新为卡片 ${moduleIndex + 1} 的颜色`);
}

// 辅助函数：RGB转HSL
function rgbToHsl(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return [h, s, l];
}

// 辅助函数：HSL转RGB
function hslToRgb(h, s, l) {
    let r, g, b;

    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }

    if (s === 0) {
        r = g = b = l;
    } else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }

    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255)
    ];
}

// 🔄 全局重置场景切换状态（调试用）
window.resetSceneTransition = function () {
    sceneTransitionManager.reset();
    console.log("🔄 场景切换状态已重置");
};

// 🔍 全局查看场景切换状态（调试用）
window.getSceneTransitionStatus = function () {
    const status = {
        isTransitioning: sceneTransitionManager.isTransitioning,
        currentTargetCard: sceneTransitionManager.currentTargetCard,
        pendingTransitions: sceneTransitionManager.pendingTransitions.size,
        timeSinceLastTransition: Date.now() - sceneTransitionManager.lastTransitionTime,
        cooldownRemaining: Math.max(0, sceneTransitionManager.transitionCooldown - (Date.now() - sceneTransitionManager.lastTransitionTime))
    };

    console.log("📊 场景切换状态:", status);
    return status;
};

// 🎯 全局强制跳转到指定卡片（调试用）
window.forceJumpToCard = function (cardIndex) {
    console.log(`🎯 强制跳转到卡片 ${cardIndex + 1}`);
    sceneTransitionManager.reset();

    const moduleId = cardIndex + 1;
    const module = modules.find(m => m.id === moduleId);

    if (module) {
        performSecondaryButtonAction(moduleId, module);
    } else {
        console.error(`❌ 未找到卡片 ${cardIndex + 1} 对应的模块`);
    }
};

console.log("🛠️ 场景切换调试功能已加载:");
console.log("   resetSceneTransition() - 重置场景切换状态");
console.log("   getSceneTransitionStatus() - 查看当前状态");
console.log("   forceJumpToCard(index) - 强制跳转到指定卡片");

// 场景缓存管理器
const sceneCacheManager = {
    cache: new Map(),
    maxCacheSize: 5,
    preloadQueue: [],           // 预加载队列
    isPreloading: false,        // 预加载状态

    // 添加场景到缓存
    addToCache: function (cardIndex, sceneData) {
        console.log(`📦 缓存场景: ${cardIndex + 1}`);

        if (this.cache.size >= this.maxCacheSize) {
            const oldestKey = this.cache.keys().next().value;
            this.cache.delete(oldestKey);
            console.log(`🗑️ 移除旧缓存: ${oldestKey + 1}`);
        }

        this.cache.set(cardIndex, {
            data: sceneData,
            timestamp: Date.now(),
            accessCount: 0      // 访问计数
        });

        // 预加载相邻场景
        this.queuePreload(cardIndex);
    },

    // 从缓存获取场景
    getFromCache: function (cardIndex) {
        const cached = this.cache.get(cardIndex);
        if (cached) {
            cached.accessCount++;  // 增加访问计数
            cached.timestamp = Date.now();  // 更新访问时间
            console.log(`✨ 使用缓存场景: ${cardIndex + 1}`);
            return cached.data;
        }
        return null;
    },

    // 检查场景是否已缓存
    isCached: function (cardIndex) {
        return this.cache.has(cardIndex);
    },

    // 预加载相邻场景
    queuePreload: function (currentIndex) {
        // 清空当前预加载队列
        this.preloadQueue = [];

        // 添加相邻场景到预加载队列
        const adjacentIndices = [currentIndex - 1, currentIndex + 1];
        for (const index of adjacentIndices) {
            if (index >= 0 && index < modules.length && !this.isCached(index)) {
                this.preloadQueue.push(index);
            }
        }

        // 开始预加载过程
        this.startPreloading();
    },

    // 开始预加载过程
    startPreloading: function () {
        if (this.isPreloading || this.preloadQueue.length === 0) return;

        this.isPreloading = true;
        const nextIndex = this.preloadQueue.shift();

        if (typeof window.TimelineControl !== 'undefined' && window.TimelineControl.preloadCard) {
            console.log(`🔄 预加载场景: ${nextIndex + 1}`);
            window.TimelineControl.preloadCard(nextIndex)
                .then(sceneData => {
                    if (sceneData) {
                        this.addToCache(nextIndex, sceneData);
                    }
                    this.isPreloading = false;
                    this.startPreloading(); // 继续预加载队列中的下一个
                })
                .catch(() => {
                    this.isPreloading = false;
                    this.startPreloading();
                });
        }
    },

    // 清理过期缓存
    clearOldCache: function (maxAge = 300000) {
        const now = Date.now();
        for (const [cardIndex, cacheData] of this.cache.entries()) {
            if (now - cacheData.timestamp > maxAge && cacheData.accessCount < 3) {
                this.cache.delete(cardIndex);
                console.log(`🗑️ 清理过期缓存: ${cardIndex + 1}`);
            }
        }
    }
};